import {Component, Inject, ViewChild} from '@angular/core';
import {RdsDropdownModule, RdsMenuModule, RdsMenuTriggerDirective} from "@rds/angular-components";
import {ContextMenuService, MenuListItem} from "../services/context-menu.service";
import {DOCUMENT} from "@angular/common";

@Component({
  selector: 'app-context-menu',
  standalone: true,
  imports: [
    RdsMenuModule,
    RdsDropdownModule
  ],
  templateUrl: './context-menu.component.html',
  styleUrl: './context-menu.component.scss'
})
export class ContextMenuComponent {
  @ViewChild(RdsMenuTriggerDirective) trigger!: RdsMenuTriggerDirective;
  items: Array<MenuListItem> = []

  constructor(private contextMenuService: ContextMenuService, @Inject(DOCUMENT) private document: Document) {
    this.contextMenuService.menuItemsData.subscribe((update) => {
      this.items = update.items
      this.relocatedAnchor(update.pos.x, update.pos.y)
      this.trigger.openMenu()
    })
    this.addOpenAndCloseEventToBody()
  }

  relocatedAnchor(x: number, y: number){
    const div = this.document.getElementById('menu-anchor') as HTMLDivElement
    div.style.left = `${x}px`
    div.style.top = `${y}px`
    this.trigger.updatePosition()
  }

  addOpenAndCloseEventToBody(){
    const body = this.document.querySelector('body') as HTMLBodyElement
    body.addEventListener('contextmenu', e => {
      e.preventDefault()
      e.stopPropagation()
      this.contextMenuService.openMenu(e.clientX, e.clientY)
    })

    body.addEventListener('click', () => {
      this.trigger.closeMenu()
    })
  }
}
